var PES = PES || {};
PES.ImageTooltip = function () {
    function initElement(element) {
        var tipTitle = $(element).attr('title');
        var tipText = $(element).data('content');

            var tipContent = "<p><strong>" + tipTitle + "</strong></p>" + tipText;

        tippy(element, {
            content: tipContent,
            trigger: 'click',
            distance: '-5',
            maxWidth: '240px'
        });

    }

    function init() {
        $('[data-toggle="popover"]').each(function (index, element) {
            initElement(element);
        });
    }
    return {
        init: init,
        initElement: initElement
    };
};